module.exports = __webpack_public_path__ + "static/media/splash.808d96ff.png";